import { Modal } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { HiOutlineMail } from "react-icons/hi";
import { emailTemplateList } from "../../stores/actions/emailtemplate.actions.types";
import EmailTemplateSelect from "../Common/EmailTemplateSelect";
import { emailSending } from "../../stores/actions/cart-funnel.actions.types";
import EmailTemplateSelect2 from "../Common/EmailTemplateSelect2";
import { successMessage } from "../../utilities/notification";

const ConfirmEmailSend = ({ emailTemplateList, emailSending }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [emailloading, setEmailLoading] = useState(true);

  const validationSchema = Yup.object({
    template: Yup.string().required("Email template is required"),
  });

  const close = () => setIsModalOpen(false);

  useEffect(() => {
    setEmailLoading(true);
    emailTemplateList({
      data: { size: 10000 },
      callback: (res) => {
        if (res.success) {
          setTemplates(res?.data?.emailTemplates || []);
        }
        setEmailLoading(false);
      },
    });
  }, [emailTemplateList, isModalOpen]);

  const handleSubmit = (values) => {
    setLoading(true);
    const callback = (data) => {
      setLoading(false);
      if (data.success) {
        setIsModalOpen(false);
      }
    };

    const request = { data: { template: values.template }, callback };
    emailSending(request);
  };

  return (
    <div>
      <button
        onClick={() => setIsModalOpen(true)}
        className='hover:text-primary bg-white rounded px-3 flex items-center gap-2 py-1'
      >
        <HiOutlineMail className='text-lg' />
        Send Email
      </button>

      <Modal
        centered
        size='lg'
        opened={isModalOpen}
        onClose={close}
        title='Add Email Campaign'
        overlayProps={{ backgroundOpacity: 0.1 }}
      >
        <div className='max-h-96 overflow-y-scroll'>
          <Formik
            initialValues={{
              template: "",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values, errors, touched }) => (
              <Form className='space-y-4'>
                <EmailTemplateSelect2
                  templates={templates}
                  value={values.template}
                  setFieldValue={setFieldValue}
                />
                {errors.template && touched.template && (
                  <div className='text-red-500 text-sm mt-1'>
                    {errors.template}
                  </div>
                )}
                <div className='flex gap-2 justify-end mt-4'>
                  <button
                    type='submit'
                    disabled={loading}
                    className='bg-primary w-[150px] px-4 py-2 rounded text-white flex items-center justify-center'
                  >
                    {loading ? (
                      <BiLoaderAlt className='animate-spin m-auto' />
                    ) : (
                      "Send Email"
                    )}
                  </button>
                  <button
                    type='button'
                    onClick={close}
                    className='bg-gray-200 px-4 py-2 rounded text-gray-700'
                  >
                    Cancel
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state?.app?.visible,
});

export default connect(mapStateToProps, { emailSending, emailTemplateList })(
  ConfirmEmailSend
);
